<script setup lang="ts">
import { nioJsBridge, } from '@nio-wad/universal-bridge-h5';
import { computed, } from 'vue';
import type { HoroEmptyPropsData, } from '@/api/model/configDetail';
import { ERROR_PAGE_TYPE, ERROR_PAGE_INFO, } from '@/enums/configs';

const props = withDefaults(
  defineProps<{
    type: ERROR_PAGE_TYPE;
    horoEmptyPropsData?: HoroEmptyPropsData;
    useNavbar?: boolean;
    fullscreen?: boolean;
    actionText?: string;
  }>(),
  {
    type: ERROR_PAGE_TYPE.ERROR,
    useNavbar: false,
    fullscreen: true,
  }
);
const emit = defineEmits(['refresh',]);

const refresh = () => {
  emit('refresh');
};

const handleNavBack = () => {
  try {
    nioJsBridge.close();
  } catch (error) {
    window.history.back();
  }
};

const isEmptyPage = computed(() => props.type === ERROR_PAGE_TYPE.EMPTY);

const errorInfo = computed(() => {
  if (props.type === ERROR_PAGE_TYPE.LIMIT_ERROR) {
    return ERROR_PAGE_INFO[ERROR_PAGE_TYPE.LIMIT_ERROR];
  }
  if (props.type === ERROR_PAGE_TYPE.ACTIVITY_ENABLED) {
    return ERROR_PAGE_INFO[ERROR_PAGE_TYPE.ACTIVITY_ENABLED];
  }
  if (props.type === ERROR_PAGE_TYPE.EMPTY) {
    return ERROR_PAGE_INFO[ERROR_PAGE_TYPE.EMPTY];
  }
  return ERROR_PAGE_INFO[ERROR_PAGE_TYPE.ERROR];
});

const restrictionType = computed(
  () => props.horoEmptyPropsData?.type || errorInfo.value.icon
);

const restrictionGatewayData = computed(
  () => props.horoEmptyPropsData?.gatewayData
);

const linkText = computed(() => props.actionText || errorInfo.value.linkText);

</script>

<template>
  <div
    class="error"
    :class="{ 'error--restriction': !isEmptyPage }"
  >
    <h-empty
      v-if="isEmptyPage || !restrictionGatewayData"
      :type="errorInfo.icon"
      :title="errorInfo.tips"
      :subtitle="errorInfo.subtitle"
      :link-text="linkText"
      @clickTextButton="refresh"
    />
    <h-empty
      v-else-if="!fullscreen"
      :type="restrictionType"
      :gateway-data="restrictionGatewayData"
      @click-text-button="refresh"
      @click-primary-button="refresh"
    />
    <h-page-restriction
      v-else
      class="error__restriction"
      :type="restrictionType"
      :gateway-data="restrictionGatewayData"
      :use-navbar="useNavbar"
      @click-nav-back="handleNavBack"
      @click-text-button="refresh"
      @click-primary-button="refresh"
    />
  </div>
</template>

<style lang="scss" scoped>
.error {
  // margin-top: 150px;
  width: 100vw;
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;

  :deep(.h-empty__link-container) {
    display: flex;
  }
  :deep(.h-button--large) {
    min-width: 120px !important;
  }
}

.error--restriction {
  height: 100vh;
  padding-top: var(--header-height);
}

.error__restriction {
  width: 100%;
  height: 100%;
}
</style>
